/* eslint-disable */
import * as React from "react";
import { Div } from "../03-base/Div";
import { ThemePalette, ThemeShadowSizes } from "../../../theme/_Types";
import { asThemeConsumer } from "../../../theme/Theme";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
var renderers = {
    table: function (data) { return (React.createElement("div", { className: "scl-m-table__wrapper" },
        React.createElement("table", { className: "scl-m-table" }, data.children))); },
    thead: function (data) { return React.createElement("thead", { className: "scl-m-table__head" }, data.children); },
    tbody: function (data) { return React.createElement("tbody", { className: "scl-m-table__body" }, data.children); },
    tr: function (data) { return React.createElement("tr", { className: "scl-m-table__tr" }, data.children); },
    th: function (data) { return React.createElement("th", { className: "scl-m-table__th" }, data.children); },
    td: function (data) { return React.createElement("td", { className: "scl-m-table__td" }, data.children); },
};
/**
 *
 * @param props
 */
export var Markdown = function (props) { return (props.raw ? (React.createElement(Div, { theme: {
        shadow: ThemeShadowSizes.TINY,
        palette: ThemePalette.CONTRAST_PRIMARY,
    } },
    React.createElement("pre", { className: "scl-o-rte__pre" }, props.content))) : props.content ?
    (React.createElement(ReactMarkdown, { children: props.content, remarkPlugins: [remarkGfm], className: "scl-o-rte", components: renderers })) : React.createElement(Div, { className: "scl-o-rte" }, props.children)); };
/**
 *
 */
export var RTE = asThemeConsumer(Markdown);
